import BaseModal from '../Modal/Modal/Modal'
import styles from './Loader.module.less'
import { DataTestId } from 'src/constants/ui.constants'

export type LoaderPropsType = {
    title: string
}

export const Loader: React.FC<LoaderPropsType> = (props: LoaderPropsType) => {
    return (
        <BaseModal
            open={true}
            disableAnimation={true}
            closable={false}
            width={'270px'}
            className={styles['root']}
        >
            <div className={styles['modal']} data-testid={DataTestId.Loader}>
                <span className={styles['text']}>{props.title}</span>
                <span className={styles['loader']}></span>
            </div>
        </BaseModal>
    )
}
